var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGroup1247 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.527 0H11.026C4.936 0 0 4.494 0 10.038v25.039c0 5.544 4.936 10.038 11.026 10.038h27.5c6.09 0 11.027-4.495 11.027-10.038V10.038C49.553 4.494 44.616 0 38.527 0Z",
    fill: "#EB0027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.895 32.863H16.656a1.013 1.013 0 0 1-.371-.05.949.949 0 0 1-.32-.18.85.85 0 0 1-.215-.28.783.783 0 0 1 0-.67.85.85 0 0 1 .215-.28c.092-.079.2-.14.32-.18.119-.04.245-.056.371-.05h16.24a.97.97 0 0 1 .622.264.807.807 0 0 1 .254.581c0 .216-.091.424-.254.581a.97.97 0 0 1-.623.264Z",
    fill: "#3B3735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.053 21.92c2.43-2.212 2.43-5.798 0-8.01-2.43-2.212-6.368-2.212-8.798 0-2.43 2.212-2.43 5.798 0 8.01 2.43 2.212 6.369 2.212 8.798 0Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.62 19.706c1.087-.989 1.087-2.593 0-3.582-1.086-.99-2.847-.99-3.934 0-1.086.99-1.086 2.593 0 3.582 1.087.99 2.848.99 3.935 0Z",
    fill: "#3B3735"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.273 23.145c3.175-1.197 4.682-4.51 3.367-7.4-1.314-2.89-4.954-4.263-8.128-3.066-3.175 1.197-4.682 4.51-3.367 7.4 1.315 2.89 4.954 4.263 8.128 3.066Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.957 20.252c1.42-.535 2.093-2.017 1.505-3.31-.588-1.292-2.215-1.906-3.635-1.37-1.42.535-2.093 2.017-1.505 3.31.587 1.292 2.215 1.905 3.635 1.37Z",
    fill: "#3B3735"
  })));
};
export { SvgGroup1247 as ReactComponent };
export default __webpack_public_path__ + "10e9d3e63aa113b59a018867d985b202.svg";